module.exports = __webpack_public_path__ + "static/media/boom-math-reversed.cc11195d.png";